import ky from 'ky';

import { env } from '@/env';
import { tokenStorage } from '@/lib/auth/tokenStorage';

// Dedicated ky instance for the central auth service (identity.signcare.io).
// `credentials: 'include'` sends the HttpOnly SSO cookie for silent re-auth.
// The beforeRequest hook attaches the Bearer token when one exists — needed
// for authenticated endpoints like /auth/profile and /auth/complete-onboarding.
// Public endpoints (login, signup, token exchange) have no token in storage
// yet, so the header is simply not set — correct behaviour for those calls.
export const authClient = ky.create({
  prefixUrl: env.VITE_AUTH_URL,
  timeout: 15_000,
  retry: 0,
  credentials: 'include',
  hooks: {
    beforeRequest: [
      (request) => {
        const token = tokenStorage.getAccessToken();
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
  },
});
